import { Component, ElementRef, OnInit } from '@angular/core';
const LINK_ATTRIBUTES = ['normal-link', 'secondary-link', 'pro-link', 'text-link'];
@Component({
    selector: 'gl-link, a[normal-link], a[secondary-link], a[pro-link], a[text-link]',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
    standalone: false
})
export class LinkComponent implements OnInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  public ngOnInit() {
    LINK_ATTRIBUTES.forEach((attr) => {
      if (this.hasAttribute(attr)) {
        this.el.nativeElement.classList.add(attr);
      }
    });
  }

  private hasAttribute(attribute: string) {
    return this.el.nativeElement.hasAttribute(attribute);
  }
}
